import * as React from "react";
import { forwardRef } from "react";
const SvgAnomaly = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 16 16",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	clipRule: "evenodd",
	d: "M7.9264 3.59167L5.57928 12.5588C5.35821 13.4034 4.19247 13.4492 3.90766 12.6244L2.97568 9.92535L2.23266 11.9337C2.10459 12.2798 1.77811 12.5092 1.41337 12.5092H0.75C0.335786 12.5092 0 12.1688 0 11.749C0 11.3291 0.335786 10.9888 0.75 10.9888H0.98025L2.17666 7.75496C2.46391 6.97855 3.55157 6.99073 3.82182 7.77338L4.65124 10.1754L7.14199 0.659483C7.37767 -0.240911 8.64828 -0.211292 8.84289 0.699111L11.4569 12.9279L12.7024 9.70158C12.975 8.99562 13.9391 8.9392 14.29 9.60867L15.0133 10.9888H15.25C15.6642 10.9888 16 11.3291 16 11.749C16 12.1688 15.6642 12.5092 15.25 12.5092H14.6376C14.314 12.5092 14.0168 12.3281 13.8649 12.0384L13.6036 11.5397L12.0993 15.4361C11.7836 16.254 10.6128 16.1591 10.4293 15.3008L7.9264 3.59167Z",
	fill: "#EB5757",
	fillRule: "evenodd"
}));
const ForwardRef = forwardRef(SvgAnomaly);
export default ForwardRef;
